<template>
  <div class="subscribe-process-wrapper">
    <ModuleTitle title="新基金认购流程"/>
    <div class="subscribe-process">
      <div class="process-main">
        <div class="process-left-line"></div>
        <div class="process-desc">
          <div v-for="(item, index) in dataList"
                :key="index" class="desc-item">
            <div class="desc-num">
              <!-- <span class="desc-num-text">{{index + 1}}</span> -->
            </div>
            <div>
              <div class="desc-title">
                <span>{{item.title}}</span>
              </div>
              <div class="desc-content">
                <span class="content-title">{{item.content}}</span>
                <span class="desc-link"
                      v-if="item.linkUrl"
                      @click="onClick(item.linkUrl)">{{item.linkText}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';
import ModuleTitle from '@/components/ModuleTitle.vue';
import StoreManger from '@/utils/FundHQJHManger';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  computed: {
  },
  components: {
    ModuleTitle,
  },
  mounted() {
    this.baseInfo = StoreManger.getFundJJXQ();
    this.configList(this.baseInfo);
  },
  data() {
    return {
      baseInfo: null,
      fundCode: '',
      dataList: [{
        title: '认购募集期',
        content: '--',
      }, {
        title: '验证备案',
        content: '--',
      }, {
        title: '封闭运作',
        content: '--',
      }, {
        title: '开放申购赎回',
        content: '--',
      }],
    };
  },
  methods: {
    render() {
      const baseinfo = StoreManger.getFundJJXQ();
      this.configList(baseinfo);
    },
    configList(item) {
      if (isEmpty(item)) {
        return;
      }
      let list = [];
      if (item) {
        list = [{
          title: '认购募集期',
          content: this.getCollectPeriod(),
        }, {
          title: '验证备案',
          content: `基金成立时间：募集结束后${item.YZBA}。成立后下一交易日可查看基金份额。`,
        }, {
          title: '封闭建仓期',
          linkText: '了解详情 >',
          linkUrl: 'https://helpmob.1234567.com.cn/m/q_891.html?&rand=',
          content: `封闭建仓期${item.FBYZQ}，期间基金经理将会对基金进行投资，基金会定期公布净值，但不可买入和卖出。`,
        }, {
          title: '开放申购赎回',
          content: item.KFSGSH,
        }];
      }
      this.dataList = list;
    },
    onClick(url) {
      detailPushPage({
        type: 2,
        url,
      });
    },
    getCollectPeriod() {
      if (!StoreManger.getFundJJXQ()) {
        return '';
      }

      const { ISSBDATE, ISSEDATE } = StoreManger.getFundJJXQ();
      if (isEmpty(ISSBDATE) || isEmpty(ISSEDATE)) {
        return '';
      }
      return `募集期：${ISSBDATE.substr(0, 10)}~${ISSEDATE.substr(0, 10)}。募集期内提交的认购申请，至基金成立期间，认购金额可享银行活期收益。`;
    },
  },
};
</script>

<style lang="less">
.subscribe-process-wrapper{
  background: #fff;
  margin-top: 24px;
  margin-bottom: 24px;
  margin-left: 24px;
  margin-right: 24px;
  border-radius: 12px;
}
.subscribe-process {
  padding: 30px;
  padding-top: 28px;
  padding-bottom: 4px;
  .process-main {
    position: relative;

    .process-left-line {
      position: absolute;
      left: 16px;
      top: 15px;
      bottom: 95px;
      width: 4px;
      background: #ff4400;
      opacity: 0.2;
      z-index: 1;
    }

    .process-desc {
      position: relative;
      z-index: 100;
    }
  }
  .desc-content-last {
    margin-left: 56px;
  }

  .desc-content-last,
  .desc-content {
    font-size: 28px;
    color: #666;
    line-height: 1.7;
  }

  .desc-link {
    color: #008aff;
  }
}

.desc-item {
  display: flex;
  margin-bottom: 10px;
  .desc-num {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px 20px 5px 8px;
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    font-family: DINAlternate-Bold;
    font-size: 28px;
    line-height: 36px;
    text-align: center;
    color: #ff4400;
    background: #ff7748;
    border: 2px solid #ffffff;
    border-radius: 50%;
  }

  .desc-num-text{
    height: 36px;
  }

  .desc-title {
    font-size: 32px;
    line-height: 46px;
  }

  .desc-content {
    margin: 10px 0 20px;
    line-height: 1.7;
  }
  .content-title{
    line-height: 40px;
  }
}
</style>
